import script from "./DevicePreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./DevicePreview.vue?vue&type=script&lang=ts&setup=true"

import "./DevicePreview.vue?vue&type=style&index=0&id=2da81ca8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da81ca8"]])

export default __exports__